import React from 'react';

import { BenefitType, getBenefitIcon } from '@epi-constants/benefitTypes';
import { EditIcon, Box, Button, ButtonMode, ButtonSize } from 'edenred-ui';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { IBeneficiaryActions } from '@epi-models/pages/Beneficiaries';

import {
  ActionButton,
  BenefitIcons,
  ButtonContent
} from '../BeneficiariesTable.styled';

export const BeneficiaryActions = ({
  beneficiary,
  showDetail,
  groupSetting,
  endOfFundsDatePassed
}: IBeneficiaryActions) => {
  const { t } = useTranslation();
  const { primaryFrontColor, altGray1 } = useTheme();
  const editBeneficiary = (e: React.MouseEvent) => {
    e.stopPropagation();
    showDetail(beneficiary.personId);
  };

  const isBenefitACtiveForUser = (type: string): boolean => {
    if (!groupSetting?.benefitSettings) return false;
    return groupSetting?.benefitSettings.some(
      s => s.benefitType.toLowerCase() === type.toLowerCase()
    );
  };
  const getBenefitIconByState = (type: string) => {
    const color =
      !endOfFundsDatePassed && isBenefitACtiveForUser(type)
        ? primaryFrontColor
        : altGray1;

    return getBenefitIcon(t, type, color);
  };

  return (
    <Box
      position="relative"
      display="flex"
      justifyContent="flex-end"
      alignItems="center"
    >
      <BenefitIcons display="flex">
        {Object.values(BenefitType)
          .sort(
            (a, b) =>
              Number(isBenefitACtiveForUser(b)) -
              Number(isBenefitACtiveForUser(a))
          )
          .map(benefitType => (
            <Box display="inline" key={benefitType} mr={1}>
              {getBenefitIconByState(benefitType)}
            </Box>
          ))}
      </BenefitIcons>
      {!endOfFundsDatePassed && (
        <ActionButton position="absolute" right={0}>
          <Button
            id={`edit-employee-btn-${beneficiary.personId}`}
            mode={ButtonMode.Secondary}
            size={ButtonSize.Small}
            onClick={editBeneficiary}
          >
            <ButtonContent>
              <EditIcon />
              {t('containers.beneficiaries.detail.edit_title')}
            </ButtonContent>
          </Button>
        </ActionButton>
      )}
    </Box>
  );
};
